import { useTheme } from '@emotion/react';
import { IconChevronLeftSmall } from '@hubble/icons';
import { spacing, size } from '@hubble/tokens/web';
import React__default from 'react';
import { Button } from '../../Button/index.js';
import { Flex } from '../../Flex/index.js';
import { Text } from '../../Text/index.js';
import { isNamedComponent } from '../utils.js';
import { PAGE_HEADER_ACTIONS_DISPLAY_NAME, ACTIONS_BUTTON_SIZE_MAP } from './constants.js';
import { jsx, jsxs } from '@emotion/react/jsx-runtime';

const Actions = ({
  children,
  size = 'md'
}) => {
  const renderChildren = [];
  React__default.Children.forEach(children, (child, index) => {
    if (React__default.isValidElement(child)) {
      renderChildren.push(React__default.cloneElement(child, {
        size,
        key: index
      }));
    }
  });
  return jsx(Flex, {
    alignItems: "end",
    gap: spacing[12],
    children: renderChildren
  });
};
Actions.displayName = PAGE_HEADER_ACTIONS_DISPLAY_NAME;
const Root = ({
  variant = 'l1',
  visualElement,
  handleBack,
  heading,
  subHeading,
  leftElement,
  rightElement
}) => {
  const {
    colorScheme
  } = useTheme();
  let renderEndElement = undefined;
  if (React__default.isValidElement(rightElement)) {
    if (isNamedComponent(rightElement, PAGE_HEADER_ACTIONS_DISPLAY_NAME)) {
      renderEndElement = React__default.cloneElement(rightElement, {
        size: ACTIONS_BUTTON_SIZE_MAP[variant]
      });
    } else {
      console.group('PageHeader error');
      console.error('Invalid child:', rightElement);
      console.error('Please use PageHeader.Actions');
      console.groupEnd();
    }
  }
  if (variant === 'l2') {
    return jsxs(Flex, {
      height: size[64],
      alignItems: "center",
      children: [leftElement ? leftElement : jsxs(Flex, {
        alignItems: "center",
        flex: "1 0 0",
        gap: spacing[12],
        children: [Boolean(handleBack) && jsx(Button.Secondary, {
          size: "sm",
          "aria-label": "Back",
          icon: jsx(IconChevronLeftSmall, {}),
          onClick: handleBack
        }), visualElement, Boolean(heading) && jsxs(Flex, {
          alignItems: "baseline",
          gap: spacing[8],
          children: [jsx(Text.Heading, {
            size: "xs",
            as: "h1",
            children: heading
          }), subHeading && jsx(Text.Body, {
            size: "xs",
            bold: true,
            color: colorScheme.content.secondary,
            children: subHeading
          })]
        })]
      }), renderEndElement]
    });
  }
  return jsxs(Flex, {
    height: size[64],
    alignItems: "center",
    children: [leftElement ? leftElement : jsx(Flex, {
      flex: "1 0 0",
      children: jsx(Text.Heading, {
        size: "lg",
        as: "h1",
        children: heading
      })
    }), renderEndElement]
  });
};
const PageHeader = Object.assign(Root, {
  Actions
});

export { PageHeader };
